import React from 'react';
import { Modal } from 'antd';

const SbModal = ({
  open = false,
  title,
  children,
  onCancel,
  closeIcon,
  ...rest
}) => {

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      {...rest}
    >
      {children}
    </Modal>
  );
};

// Expose Ant Design Modal static methods
SbModal.confirm = Modal.confirm;
SbModal.info = Modal.info;
SbModal.success = Modal.success;
SbModal.error = Modal.error;
SbModal.warning = Modal.warning;

export default SbModal;
